.container {
  display: inline-block;
  max-width: 100%;

  > span {
    font-size: var(--md-font-size);
    font-weight: 400;
    line-height: 22px;
    gap: 3.5px;
    display: flex;
    align-items: center;
  }
}

.count {
  flex: 1 0;
  margin: 0 0 0 3.5px;
  color: var(--neutral-7-color);
  white-space: nowrap;
}
